import { RouteType } from '../../../types/RouteType'
import { RootStore } from '@intrasync/stores'

const InvoiceDetailRoute: RouteType = {
  name: 'Invoice Detail',
  path: '/accounting/invoice/:invoiceId',
  layout: '/app',
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  hidden: true,
  // group: 'Accounting',

  viewportCard: {
    header: {
      component: () => import('./components/InvoiceDetailHeader'),
      title: 'Invoice Details',
      color: 'primary',
      enableRefreshButton: true,
      enableBackButton: true
    },
    body: {
      component: () => import('./components/InvoiceDetailBody'),
      grayBackground: true
    }
  },

  beforeEnter: async ({ rootStore, params }: { rootStore: RootStore, params: any }) => {
    const { invoiceId } = params

    if (!invoiceId) {
      return false
    }

    try {
      // Load the invoice - try both get and find methods
      const invoicesStore = (rootStore as any).invoicesStore
      if (invoicesStore) {
        try {
          // First try to get the specific invoice
          await invoicesStore.get(invoiceId)
        } catch (error) {
          // If get fails, try finding all invoices and look for the one we need
          await invoicesStore.find({})
        }
      }

      // Try to find the invoice in the store
      const invoice = invoicesStore?.entities?.find((inv: any) =>
        inv.invoiceId === invoiceId ||
        inv.id === invoiceId ||
        String(inv.invoiceId) === String(invoiceId) ||
        String(inv.id) === String(invoiceId)
      )

      if (invoice?.purchaseOrderId) {
        const purchaseOrdersStore = (rootStore as any).purchaseOrdersStore
        if (purchaseOrdersStore) {
          try {
            await purchaseOrdersStore.get(invoice.purchaseOrderId)
          } catch (error) {
            // PO may already be loaded
          }
        }

        // Load PO line items - they should already be loaded from conversion
        const purchaseOrderLineItemsStore = (rootStore as any).purchaseOrderLineItemsStore
        if (purchaseOrderLineItemsStore && purchaseOrderLineItemsStore.entities.length === 0) {
          await purchaseOrderLineItemsStore.find({})
        }
      }

      // Load account (customer) details
      if (invoice?.customerId) {
        const customersStore = (rootStore as any).customersStore
        if (customersStore) {
          try {
            await customersStore.get(invoice.customerId)
          } catch (error) {
            await customersStore.find({})
          }
        }
      }

      // Load users if not already loaded
      const userStore = (rootStore as any).userStore
      if (userStore && userStore.entities.length === 0) {
        await userStore.find({})
      }

    } catch (error) {
      // Don't return false - let the page load and show what it can
    }

    return true
  },

  onParamsChange: async ({ rootStore, params }: { rootStore: RootStore, params: any }) => {
    const { invoiceId } = params

    if (invoiceId) {
      const invoicesStore = (rootStore as any).invoicesStore
      if (invoicesStore) {
        await invoicesStore.get(invoiceId)
      }
    }
  },

  dialogs: [
    {
      name: 'EditInvoice',
      component: () => import('./dialogs/EditInvoiceDialog'),
      title: 'Edit Invoice',
      height: 600,
      cancelButton: true
    },
    {
      name: 'SendInvoice',
      component: () => import('./dialogs/SendInvoiceDialog'),
      title: 'Send Invoice',
      height: 400,
      cancelButton: true
    }
  ]
}

export default InvoiceDetailRoute